/*
 * The slider component holds logic to display a carousel slider.
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '@components/base/base.component';
import { CarouselComponent } from '@components/ivy-carousel/carousel.component';
import { LinkAsTypes, LinkRelTypes } from '@enums/link-types.enum';
import { GetImageUrlDirectus } from '@pipes/get-image-url-direcuts/get-image-url-directus.pipe';
import { BaseService } from '@services/base/base.service';
import { LinkService } from '@services/link/link.service';
import { SlidesService } from '@services/slides/slides.service';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-component-slider',
    templateUrl: 'slider.component.html',
    styleUrls: ['slider.component.less']
})
export class SliderComponent extends BaseComponent implements OnInit {

    @ViewChild('sliderCarousel', { static: false }) sliderCarousel: CarouselComponent;
    sliderInterval: number = 5000;
    sliderLength: number = 0;

    constructor(
        public baseService: BaseService,
        private linkService: LinkService,
        private slidesService: SlidesService,
        private getImageUrlDirectus: GetImageUrlDirectus
    ) {
        super(baseService);
    }

    ngOnInit() {
        this.item = this.slidesService.get('title,claim,text,image_landscape,image_portrait,url,translations.*').pipe((tap((slides: any[]) => {
            if (slides && slides.length) {
                this.linkService.createLink(this.getImageUrlDirectus.transform(slides[0].image_landscape, 70), LinkRelTypes.PRELOAD, LinkAsTypes.IMAGE);
                this.sliderLength = slides.length;
            } else {
                this.sliderLength = 0;
            }
        })));
    }

    public handleCarouselEvents(event: any) {
        let timeout;

        if (event && event.name === 'next' && event.counter && event.counter === this.sliderLength - 1) {
            timeout = setTimeout(() => {
                this.sliderCarousel.select(0);
            }, this.sliderInterval)
        }

        if (timeout && event && (event.name !== 'next' && event.name !== 'transitionend') || (event.name === 'move' || event.name) === 'touchend' && timeout) {
            clearTimeout(timeout);
        }
    }
}